<script setup>
import SvgIcon from "@/shared/ui/svg-icon/SvgIcon.vue";

defineProps({
  results: {
    type: Object,
    required: true,
    // { existingCase: { found: boolean }, testament: { found: boolean }, statement: { found: boolean } }
  },
});
</script>

<template>
  <div class="flex flex-col gap-1 mt-1">
    <div class="flex items-center gap-2">
      <svg-icon
        :name="results.existingCase?.found ? 'huge-close' : 'huge-check-mark'"
        class="w-4 h-4 shrink-0"
        :class="
          results.existingCase?.found ? 'text-red-500' : 'text-muted-foreground'
        "
      />
      <span
        class="text-sm"
        :class="
          results.existingCase?.found ? 'text-red-500' : 'text-muted-foreground'
        "
      >
        {{
          results.existingCase?.found
            ? $t("Обнаружено наследственное дело")
            : $t("Наследственных дел не обнаружено")
        }}
      </span>
    </div>
    <div class="flex items-center gap-2">
      <svg-icon
        name="huge-check-mark"
        class="w-4 h-4 text-muted-foreground shrink-0"
      />
      <span class="text-sm text-muted-foreground">
        {{
          results.testament?.found
            ? $t("Найдено завещание")
            : $t("Завещания не найдено")
        }}
      </span>
    </div>
    <div class="flex items-center gap-2">
      <svg-icon
        :name="
          results.statement?.found === false ? 'huge-close' : 'huge-check-mark'
        "
        class="w-4 h-4 shrink-0"
        :class="
          results.statement?.found === false
            ? 'text-red-500'
            : 'text-muted-foreground'
        "
      />
      <span
        class="text-sm"
        :class="
          results.statement?.found === false
            ? 'text-red-500'
            : 'text-muted-foreground'
        "
      >
        {{
          results.statement?.found === false
            ? $t("Заявление не найдено")
            : $t("Заявление найдено")
        }}
      </span>
    </div>
  </div>
</template>
